import $api from 'http'
import $apiJSON from 'http/apiJSON'

export async function getMyMembers(service, data) {
  return $api.get(`/employees/teams/${service}/`, data)
}


export async function createNewTeam(name_team) {
  return $apiJSON.post('/employees/commands/', { name_team })
}
export async function AnswerToInvite(id, members) {
  return $apiJSON.patch(`/employees/command/${id}/`, members)
}

// Guard (Охранник КПП)
export async function createGuard(payload) {
  // payload: { employee: id, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/guards/', payload)
}

export async function getGuards(params) {
  // params: optional query params for pagination/filtering
  return $api.get('/tabel/guards/', { params })
}

// TopBase (ТОП-База)
export async function createTopBase(payload) {
  // payload: { name: string, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/top-bases/', payload)
}

export async function getTopBases(params) {
  return $api.get('/tabel/top-bases/', { params })
}

// TopBaseOperator (Оператор ТОП-базы)
export async function createTopBaseOperator(payload) {
  // payload: { top_base: id, employee: id, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/top-base-operators/', payload)
}

export async function getTopBaseOperators(params) {
  return $api.get('/tabel/top-base-operators/', { params })
}

export async function updateTopBaseOperator(id, payload) {
  return $apiJSON.patch(`/tabel/top-base-operators/${id}/`, payload)
}

// Driver (Водитель)
export async function createDriver(payload) {
  // payload: { employee: id, vehicle_number: string, vehicle_model?: string, phone?: string }
  // If uploading files (photo), ensure $apiJSON supports multipart form data.
  return $apiJSON.post('/tabel/drivers/', payload)
}

export async function getDrivers(params) {
  return $api.get('/tabel/drivers/', { params })
}

export async function updateDriver(id, payload) {
  return $apiJSON.patch(`/tabel/drivers/${id}/`, payload)
}

export async function blockDriver(id) {
  return $apiJSON.post(`/tabel/drivers/${id}/block/`)
}

export async function unblockDriver(id) {
  return $apiJSON.post(`/tabel/drivers/${id}/unblock/`)
}

export async function getAllEmployees(data) {
  return $api.get(`/employees/all-employees/`, data)
}

export async function updateGuard(id, payload) {
  return $apiJSON.patch(`/tabel/guards/${id}/`, payload)
}

export async function updateTopBase(id, payload) {
  return $apiJSON.patch(`/tabel/top-bases/${id}/`, payload)
}

// =========================
// CHPP (ТЭЦ) — duplicated logic from TopBase
// NOTE: Endpoint names assumed. Adjust if backend differs.
// =========================
export async function createChpp(payload) {
  // payload: { name: string, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/chpps/', payload)
}

export async function getChpps(params) {
  return $api.get('/tabel/chpps/', { params })
}

export async function updateChpp(id, payload) {
  return $apiJSON.patch(`/tabel/chpps/${id}/`, payload)
}

// CHPP Operator (Оператор ТЭЦ)
export async function createChppOperator(payload) {
  // payload: { chpp: id, employee: id, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/top-base-operators/', payload)
}

export async function getChppOperators(params) {
  return $api.get('/tabel/top-base-operators/', { params })
}

export async function updateChppOperator(id, payload) {
  return $apiJSON.patch(`/tabel/top-base-operators/${id}/`, payload)
}

// Drivers for CHPP reuse /tabel/drivers/ with query param chpp
// Existing createDriver/getDrivers/updateDriver already suitable; just pass { chpp: <id> } where needed.

// =========================
// PrivatePoint (Соц. Объекты и МСУ)
// =========================
export async function createPrivatePoint(payload) {
  // payload: { name: string, phone?: string, is_active?: boolean, geo?: string }
  return $apiJSON.post('/tabel/private-points/', payload)
}

export async function getPrivatePoints(params) {
  return $api.get('/tabel/private-points/', { params })
}

export async function updatePrivatePoint(id, payload) {
  return $apiJSON.patch(`/tabel/private-points/${id}/`, payload)
}

// PrivatePoint Operator (Оператор соц.объекта или МСУ)
export async function createPrivatePointOperator(payload) {
  // payload: { private_point: id, employee: id, phone?: string, is_active?: boolean }
  return $apiJSON.post('/tabel/top-base-operators/', payload)
}

export async function getPrivatePointOperators(params) {
  return $api.get('/tabel/top-base-operators/', { params })
}

export async function updatePrivatePointOperator(id, payload) {
  return $apiJSON.patch(`/tabel/top-base-operators/${id}/`, payload)
}

// Drivers for PrivatePoint reuse /tabel/drivers/ with query param private_point
// Existing createDriver/getDrivers/updateDriver already suitable; just pass { private_point: <id> } where needed.

// =========================
// Branches (Филиалы)
// =========================
export async function getTopBaseBranches(topBaseId, params) {
  return $api.get(`/tabel/top-bases/${topBaseId}/branches/`, { params })
}

export async function createTopBaseBranch(topBaseId, payload) {
  // payload: { name: string, address?: string, geo?: string, is_active?: boolean }
  return $apiJSON.post(`/tabel/top-bases/${topBaseId}/branches/`, payload)
}

export async function getChppBranches(chppId, params) {
  return $api.get(`/tabel/chpps/${chppId}/branches/`, { params })
}

export async function createChppBranch(chppId, payload) {
  return $apiJSON.post(`/tabel/chpps/${chppId}/branches/`, payload)
}

export async function getPrivatePointBranches(privatePointId, params) {
  return $api.get(`/tabel/private-points/${privatePointId}/branches/`, { params })
}

export async function createPrivatePointBranch(privatePointId, payload) {
  return $apiJSON.post(`/tabel/private-points/${privatePointId}/branches/`, payload)
}

export async function updateBranch(id, payload) {
  return $apiJSON.patch(`/tabel/branches/${id}/`, payload)
}

export async function getBranches(params) {
  return $api.get('/tabel/branches/', { params })
}

// =========================
// Driver Documents
// =========================
export async function uploadDriverDocuments(driverId, files) {
  const formData = new FormData()
  files.forEach(file => {
    formData.append('files', file)
  })
  return $api.post(`/tabel/drivers/${driverId}/upload_documents/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export async function getDriverDocuments(driverId) {
  return $api.get(`/tabel/drivers/${driverId}/documents/`)
}

export async function deleteDriverDocument(driverId, documentId) {
  return $api.delete(`/tabel/drivers/${driverId}/documents/${documentId}/`)
}

// TopBase Operator Documents (ТЭЦ, МСУ, соц.объекты)
// =========================
export async function uploadOperatorDocuments(operatorId, files) {
  const formData = new FormData()
  files.forEach(file => {
    formData.append('files', file)
  })
  return $api.post(`/tabel/topbase-operators/${operatorId}/upload_documents/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export async function getOperatorDocuments(operatorId) {
  return $api.get(`/tabel/topbase-operators/${operatorId}/documents/`)
}

export async function deleteOperatorDocument(operatorId, documentId) {
  return $api.delete(`/tabel/topbase-operators/${operatorId}/documents/${documentId}/`)
}

// =========================
// Search (Поиск баз для быстрого выбора)
// =========================
export async function searchTopBases(search, limit = 20) {
  return $api.get('/tabel/search/top-bases/', { params: { search, limit } })
}

export async function searchChpps(search, limit = 20) {
  return $api.get('/tabel/search/chpps/', { params: { search, limit } })
}

export async function searchPrivatePoints(search, limit = 20) {
  return $api.get('/tabel/search/private-points/', { params: { search, limit } })
}